<template>
  <v-html-container
  class="question-analysis-solution"
  label="Analysis & Solution"
  :htmlContent="analysisSolution"
  ></v-html-container>
</template>
<script>
import HtmlContainer from './sub/HtmlContainer'

export default {
  name: 'AnalysisAnswer',
  components: {
    'v-html-container': HtmlContainer
  },
  props: {
    analysis: {
      type: String,
      default: '',
      required: true
    },
    answer: {
      type: String,
      default: '',
      required: true
    }
  },
  computed: {
    blockAnalysis () {
      return this.analysis
    },
    blockSolution () {
      return this.answer
    },
    analysisSolution () {
      return `${this.analysis}${this.answer}`
    }
  }
}
</script>
